"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PARAGRAPH_TYPES = exports.PARAGRAPH_TYPE_SECONDARY = exports.PARAGRAPH_TYPE_HIGHLIGHTS = exports.PARAGRAPH_TYPE_TITLE = exports.PARAGRAPH_TYPE_PRIMARY = void 0;
var PARAGRAPH_TYPE_PRIMARY = 'primary';
exports.PARAGRAPH_TYPE_PRIMARY = PARAGRAPH_TYPE_PRIMARY;
var PARAGRAPH_TYPE_TITLE = 'title';
exports.PARAGRAPH_TYPE_TITLE = PARAGRAPH_TYPE_TITLE;
var PARAGRAPH_TYPE_HIGHLIGHTS = 'highlights';
exports.PARAGRAPH_TYPE_HIGHLIGHTS = PARAGRAPH_TYPE_HIGHLIGHTS;
var PARAGRAPH_TYPE_SECONDARY = 'secondary';
exports.PARAGRAPH_TYPE_SECONDARY = PARAGRAPH_TYPE_SECONDARY;
var PARAGRAPH_TYPES = [PARAGRAPH_TYPE_PRIMARY, PARAGRAPH_TYPE_HIGHLIGHTS, PARAGRAPH_TYPE_TITLE, PARAGRAPH_TYPE_SECONDARY];
exports.PARAGRAPH_TYPES = PARAGRAPH_TYPES;